import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-hospital-assessment-dialog',
  template: `
    <div class="d-flex justify-content-between align-items-center">
      <h2 mat-dialog-title class="mb-0">{{ data.hospitalName }} – Questionnaire</h2>
      <button mat-icon-button mat-dialog-close matTooltip="Close"><mat-icon>close</mat-icon></button>
    </div>
    <mat-dialog-content>
      <app-hospital-assessment [hospitalId]="data.id"></app-hospital-assessment>
    </mat-dialog-content>
  `
})
export class HospitalAssessmentDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
